import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import FamilyPanel from './FamilyPanel';
import { BaseCard } from '../../../components/wizard';

class FamilyCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    const { record = {}, data = {}, extras, setItem, ...extraProps } = this.props;
    const formdata = data.data || {};
    return (
      <Box>
        <BaseCard
          cardid={'FAMILY'}
          cardname={'Family'}
          cardtitle={'Family & Marriage'}
          instruction={'Provide marital, spouse, and family linkage information.'}
          step={4}
          buttons={['START', 'CANCEL', 'PREV', 'NEXT', 'GUIDE']}
          {...extraProps}
        >
          <FamilyPanel
            data={data}
            record={{ ...record, ...formdata }}
            extras={extras}
            setItem={setItem}
          />
        </BaseCard>
      </Box>
    );
  };
}

FamilyCard.propTypes = {
  classes: PropTypes.object,
};

export default FamilyCard;
